import _ from 'lodash'
import {useState} from 'react'
import {Button, ButtonProps, Popup} from 'semantic-ui-react'
import './style.css'

export interface IConfirmButtonProps extends ButtonProps {
  confirmText?: string
}

export function ConfirmButton(props: IConfirmButtonProps) {
  const {confirmText, color, className, onClick, ...rest} = props

  const [isOpen, setIsOpen] = useState(false)

  function handleOnTriggerClick(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    _data: ButtonProps
  ) {
    event.preventDefault()
    event.stopPropagation()
  }

  function handleOnConfirmClick(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    data: ButtonProps
  ) {
    event.preventDefault()
    event.stopPropagation()
    if (!onClick) return
    onClick(event, data)
    setIsOpen(false)
  }

  const classNames = _.chain(['confirm-button', className]).compact().join(' ').value()

  return (
    <Popup
      className='confirm-popup'
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      openOnTriggerMouseEnter={false}
      closeOnTriggerMouseLeave={false}
      trigger={
        <Button
          className={classNames}
          color={color}
          {...rest}
          onClick={handleOnTriggerClick}
        />
      }
      style={{
        zIndex: 9999999,
      }}
    >
      <Button
        compact
        size='tiny'
        icon='check'
        color={color}
        content={confirmText}
        onClick={handleOnConfirmClick}
      />
    </Popup>
  )
}
